/**
 * Base API configuration class.
 * Each frontend app extends this and adds its own endpoints.
 */
class ApiConfigBase {
  constructor() {
    this.loadConfig();
  }

  loadConfig() {
    const config = window.APP_CONFIG || {};
    this.API_GATEWAY_URL = config.apiGatewayUrl || 'http://localhost:8000/api';
    this.IDENTITY_SERVICE_URL = config.identityServiceUrl || 'http://localhost:7080';
    this.SUPPORT_PLATFORM_URL = config.supportPlatformUrl || 'http://localhost:3000';
    this.ANALYTICS_PLATFORM_URL = config.analyticsPlatformUrl || 'http://localhost:3001';
    this.OIDC_CLIENT_ID = config.oidcClientId || '';
    this.OIDC_SCOPES = config.oidcScopes || 'openid profile email offline_access roles';
    this.IDENTITY_API_KEY = config.identityApiKey || '';
    // Same-origin path to identity's browser-session endpoints. Set per app, and only
    // where nginx actually proxies them: with it the refresh token lives in an HttpOnly
    // cookie instead of JavaScript. Empty means the bearer flow, unchanged.
    this.SESSION_ENDPOINT = config.sessionEndpoint || '';
  }

  getApiGatewayUrl() {
    return this.API_GATEWAY_URL;
  }

  getIdentityServiceUrl() {
    return this.IDENTITY_SERVICE_URL;
  }

  getSupportPlatformUrl() {
    return this.SUPPORT_PLATFORM_URL;
  }

  getAnalyticsPlatformUrl() {
    return this.ANALYTICS_PLATFORM_URL;
  }

  getOidcConfig() {
    return {
      authority: this.IDENTITY_SERVICE_URL,
      clientId: this.OIDC_CLIENT_ID,
      redirectUri: `${window.location.origin}/auth/callback`,
      postLogoutRedirectUri: window.location.origin,
      scope: this.OIDC_SCOPES,
      sessionEndpoint: this.SESSION_ENDPOINT,
    };
  }
}

export default ApiConfigBase;
